(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/hooks/use-price.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/hooks/use-price.js');

'use strict';

const {
  useState,
  useEffect
} = React;
const {
  PROLONG_SUBSCRIPTION
} = svs.numbergames.prolong_game.common.constants;
const {
  productMapping,
  rules
} = svs.numbergames;

const calculateLottoPrice = _ref => {
  let {
    wager,
    numDraws,
    selectedDays
  } = _ref;
  const lottoBet = wager.wager.bets.find(bet => productMapping.isLotto(bet.productId));
  const hasLotto2 = Boolean(parseInt(lottoBet === null || lottoBet === void 0 ? void 0 : lottoBet.betAmountSalesGroup2, 10));
  const jokerBet = wager.wager.bets.find(bet => productMapping.isJoker(bet.productId));
  const jokerPrice = jokerBet ? parseInt(jokerBet.betAmountSalesGroup1, 10) / jokerBet.numDraws : 0;
  return selectedDays.reduce((totalPrice, productItsId) => {
    let price = 0;
    for (let i = 0; i < numDraws; i++) {
      const rowPrice = rules.getRules(productItsId).rowPrice;
      price += wager.rowCount * rowPrice * (hasLotto2 + 1);
      price += jokerPrice;
    }
    return totalPrice + price;
  }, 0);
};
const usePrice = (drawCount, selectedDays, wager) => {
  const {
    betAmount,
    totalDrawCount
  } = wager;
  const drawBetAmount = parseInt(betAmount, 10) / totalDrawCount;
  const [price, setPrice] = useState(betAmount);
  useEffect(() => {
    const numDraws = drawCount === PROLONG_SUBSCRIPTION ? 1 : parseInt(drawCount, 10);
    let newPrice;
    if (productMapping.isLotto(wager.productName)) {
      newPrice = calculateLottoPrice({
        wager,
        numDraws,
        selectedDays
      });
    } else {
      newPrice = drawBetAmount * selectedDays.length * numDraws;
    }
    setPrice(newPrice);
  }, [drawBetAmount, drawCount, selectedDays, wager]);
  return price;
};
setGlobal('svs.numbergames.prolong_game.hooks.usePrice', usePrice);

 })(window);